@if (ecuOptions().length > 0) {
	<div class="filter-item">
		<label class="filter-key" for="dtc-filter-ecu">DTC ECU</label>
		<p-select
			inputId="dtc-filter-ecu"
			[options]="ecuOptions()"
			[ngModel]="selectedEcu()"
			(ngModelChange)="onEcuChange($event)"
			placeholder="All"
			[filter]="true"
			filterPlaceholder="Search ECU..."
			[showClear]="true"
			[style]="{ width: '100%' }"
			data-testid="dtc-filter-ecu-select"
		/>
	</div>

	<div class="filter-item">
		<label class="filter-key" for="dtc-filter-code">DTC Code</label>
		<p-select
			inputId="dtc-filter-code"
			[options]="codeOptions()"
			[ngModel]="selectedCode()"
			(ngModelChange)="onCodeChange($event)"
			placeholder="All"
			[filter]="true"
			filterPlaceholder="Search code..."
			[showClear]="true"
			[style]="{ width: '100%' }"
			data-testid="dtc-filter-code-select"
		/>
	</div>
}
